import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inr } from "@/lib/api";
import { ShieldCheck, ArrowUpRight, Share2 } from "lucide-react";
import { catLabel, offPct } from "./categories";
import { GoldPill } from "./ProductCard";
import { ProductImage } from "./ProductImage";

export const QuickView = ({ p, onClose, onBuy, onShare }) => (
  <Dialog open={!!p} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-3xl bg-[#08382B]/90 backdrop-blur-xl border border-[#D4AF37]/30 rounded-2xl p-0 overflow-hidden" data-testid="product-quick-view">
      {p && (
        <div className="grid md:grid-cols-2">
          <div className="bg-[#06241C] p-4"><ProductImage src={p.image} alt={p.name} testid="quick-view-img" className="w-full aspect-square rounded-xl overflow-hidden ring-1 ring-[#D4AF37]/30" /></div>
          <div className="p-6 flex flex-col">
            <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#D4AF37]">{catLabel(p.category)}</p>
            <DialogHeader><DialogTitle className="font-serif text-2xl text-[#F5EFE6] text-left mt-1">{p.name}</DialogTitle></DialogHeader>
            <div className="flex items-baseline gap-3 my-4">
              <span className="text-3xl font-serif font-bold text-[#FFE9A8]">{p.price > 0 ? inr(p.price) : "See best price"}</span>
              {offPct(p) > 0 && <><span className="text-[#A3B8B0] line-through">{inr(p.mrp)}</span>
                <span className="text-xs font-bold text-emerald-300 bg-emerald-950/60 px-2 py-0.5 rounded border border-emerald-500/30">Save {offPct(p)}%</span></>}
            </div>
            {p.desc && <p className="text-sm text-[#A3B8B0] leading-relaxed">{p.desc}</p>}
            <p className="flex items-center gap-2 text-xs text-[#F5EFE6]/80 mt-4"><ShieldCheck className="w-4 h-4 text-[#D4AF37]" /> Hand-picked by Bengal Umrah House · secure checkout</p>
            <GoldPill onClick={() => onBuy(p)} testid="quick-view-secure-btn" className="mt-6 h-12 text-base">Buy Now <ArrowUpRight className="w-4 h-4" /></GoldPill>
            {onShare && <GoldPill emerald onClick={() => onShare(p)} testid="quick-view-share-btn" className="mt-3 h-11"><Share2 className="w-4 h-4" /> Share this product</GoldPill>}
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
